import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable, Subject } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';

import { Service } from '../models/service.model';
import { Stub, DefaultStub, newStub } from '../models/stub.model';
import { Config } from '../app.config';

import { environment } from '../../environments/environment'
import { SharedData } from '../shared-data/shared-object.service';

@Injectable()
export class StubsService {

  private _serviceAPIUrl;
  private _stubAPIUrl;
  private _defaultDataUrl;
  private _getSrvStubsDataUrl;
  private _CreateTemplateURL;
  private _deleteServiceUrl;
  private _editServiceUrl;
  private _getUserByIdUrl;
  private _getIdentifiersFromSpecName;
  private _getDefaultStubsStatus: string;
  private _options;
  public currentInstance;
  public _categoryCreate;
  public _categoryList;
  public _categoryUpdate;
  public _categoryRemove;
  public _stubById;
  //a variable that holds all the services
  public services: Service[] = [];

  constructor(private _http: Http, private _config: Config, private _sharedData: SharedData) {
    this._serviceAPIUrl = `${_config.baseUrl}/v1/stubs/services`;
    this._stubAPIUrl = `${_config.baseUrl}/v1/stubs/data/`;
    this._defaultDataUrl = `${_config.baseUrl}/v1/stubs/data/default/`;
    this._getSrvStubsDataUrl = `${_config.baseUrl}/v1/stubs/data/service/`;
    this._CreateTemplateURL = `${_config.baseUrl}/v1/stubs/CreateServiceTemplate`;
    this._deleteServiceUrl = `${_config.baseUrl}/v1/stubs/service/data/`;
    this._editServiceUrl = `${_config.baseUrl}/v1/stubs/service/data/`;
    this._getIdentifiersFromSpecName = `${_config.baseUrl}/v1/automation/services-spec-names/identifers/{serviceName}`;
    this._getDefaultStubsStatus = `${_config.baseUrl}/v1/stubs/automation-default-stubs/{serviceName}`;
    this._getUserByIdUrl = `${_config.ssoUrl}/id/user`;
    this._categoryCreate = `${_config.baseUrl}/v1/stubs/categories`;
    this._categoryList = `${_config.baseUrl}/v1/stubs/categories`;
    this._categoryUpdate = `${_config.baseUrl}/v1/stubs/categories`;
    this._categoryRemove = `${_config.baseUrl}/v1/stubs/categories`;
    this._stubById = `${_config.baseUrl}/v1/stubs/getStubById`;

    const headers = new Headers({ 'Content-Type': 'application/json', });
    this._options = new RequestOptions({ headers, withCredentials: true });
  }

  getServicesData(): Observable<Service[]> {
    const headers = new Headers({ 'Content-Type': 'application/json', });

    let options = new RequestOptions({ headers: headers, withCredentials: true });
    this._sharedData.clearServiceCache();
    return this._http.get(this._serviceAPIUrl, options)
      .map((response: Response) => {
        this.services = <Service[]>response.json();
        this.services.forEach(element => {
          this._sharedData.setService(element);
        });
        return this.services;
      })
      .catch(this.handleError);
  }

  getServiceByName(serviceName: string): Observable<Service> {
    let headers = new Headers({ 'Content-Type': 'application/json', });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    return this._http.get(this._stubAPIUrl + serviceName, options)
      .map((response: Response) => <Service>response.json())
      .catch(this.handleError);
  }

  getStubsData(serviceName: string, listMode?: boolean): Observable<Stub[]> {
    let headers = new Headers({ 'Content-Type': 'application/json', });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    let url: string = this._stubAPIUrl + 'service/' + serviceName;

    if (listMode) {
      url = url + '?listMode=true';
    }

    return this._http.get(url, options)
      .map((response: Response) => <Stub[]>response.json())
      .catch(this.handleError);
  }

  getStubById(serviceName: string, stubId: string) {
    let headers = new Headers({ 'Content-Type': 'application/json', });
    let options = new RequestOptions({ headers: headers, withCredentials: true });

    return this._http.get(this._stubById + `/${serviceName}/${stubId}`, options)
      .map((response: Response) => <Stub>response.json()[0])
      .catch(this.handleError);
  }

  getStubsTemplateData(serviceName: string): Observable<Stub[]> {
    let headers = new Headers({ 'Content-Type': 'application/json', });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    return this._http.get(this._serviceAPIUrl, options)
      .map((response: Response) => <Stub[]>response.json())
      .catch(this.handleError);
  }
  getServiceDefaultData(serviceName: string, respCode: string) {
    let headers = new Headers({ 'Content-Type': 'application/json', });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    return this._http.get(this._defaultDataUrl + serviceName + '?responseCode=' + respCode, options)
      .map((response: Response) => <DefaultStub[]>response.json())
      .catch(this.handleError);
  }

  deleteStubData(serviceName: string, stubID: string): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/json', });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    return this._http.delete(this._stubAPIUrl + serviceName + '?id=' + stubID, options)
      .catch(this.handleError);
  }
  deleteService(serviceId: string): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/json', });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    return this._http.delete(this._deleteServiceUrl + serviceId, options)
      .map((response: Response) => <DefaultStub[]>response.json())
      .catch(this.handleError);
  }
  putStubsData(serviceName: string, body: newStub) {
    return this._http.put(this._stubAPIUrl + serviceName, JSON.stringify(body), this._options)
      .catch(this.handleError);
  }
  getServiceStubsData(serviceName: string) {
    let headers = new Headers({ 'Content-Type': 'application/json', });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    return this._http.get(this._getSrvStubsDataUrl + serviceName, options)
      .map((response: Response) => <Stub[]>response.json())
      .catch(this.handleError);
  }
  updateStubData(serviceName: string, body: any) {
    return this._http.post(this._stubAPIUrl + serviceName, JSON.stringify(body), this._options)
      .catch(this.handleError);
  }

  CreateServiceTemplate(body: any, selectedCategories) {
    let newBody: any = JSON.stringify(body);
    newBody = JSON.parse(newBody);
    newBody.category = selectedCategories;
    return this._http.post(this._CreateTemplateURL, JSON.stringify(newBody), this._options)
      .catch(this.handleError);
  }
  UpdateServiceTemplate(body: any, id: any, selectedCategories) {
    let newBody: any = JSON.stringify(body);
    newBody = JSON.parse(newBody);
    newBody.category = selectedCategories;
    return this._http.post(this._editServiceUrl + id, JSON.stringify(newBody), this._options)
      .catch(this.handleError);
  }
  getUserById(userId: any) {
    if (environment.ssoMode) {
      return this._http.post(this._getUserByIdUrl, {
        userId: userId
      }, this._options).map((response: Response) => response.json())
        .catch(this.handleError);
    } else {
      return Observable.of({
        'user': {
          'email': 'test'
        }
      });

    }
  }

  getIdentifiersFromSpecName(serviceName: string) {

    const url = this._getIdentifiersFromSpecName.replace('{serviceName}', serviceName);

    return this._http.get(url, this._options).map((response: Response) => response.json())
      .catch(this.handleError);
  }

  public getDefaultStubsStatus(serviceName: string) {

    const url = this._getDefaultStubsStatus.replace('{serviceName}', serviceName);

    let headers = new Headers({ 'Content-Type': 'application/json', });

    let options = new RequestOptions({
      headers: headers,
      withCredentials: true
    });

    return this._http.get(url, options)
      .map((response: any) => {

        return response && response.json ? response.json() : [];
      });
  }

  private handleError(error: Response) {
    return Observable.throw(error.json().errorMessege || 'Server error');
  }

  public getCategories() {

    return this._http.get(this._categoryList, this._options)
      .map((response: any) => {
        return response;
      })
  }
  public createCategory(category) {

    return this._http.post(this._categoryCreate, { value: category }, this._options)
      .map((response: any) => {

        return response;
      })
  }
  public updateCategory(categoryId, updatedCategory) {

    return this._http.put(`${this._categoryUpdate}/${categoryId}`, { newValue: updatedCategory }, this._options)
      .map((response: any) => {

        return response;
      })
  }

  public removeCategory(categoryId) {

    return this._http.delete(`${this._categoryRemove}/${categoryId}`, this._options)
      .map((response: any) => {

        return response;
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/stubs.service.ts